import { render, staticRenderFns } from "./EditIRegSetting.vue?vue&type=template&id=616efbde&scoped=true"
import script from "./EditIRegSetting.vue?vue&type=script&lang=js"
export * from "./EditIRegSetting.vue?vue&type=script&lang=js"
import style0 from "./EditIRegSetting.vue?vue&type=style&index=0&id=616efbde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616efbde",
  null
  
)

export default component.exports